import { render, staticRenderFns } from "./histRedirect.vue?vue&type=template&id=8a5c959a&"
import script from "./histRedirect.vue?vue&type=script&lang=js&"
export * from "./histRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports